// pages/Auth/VerifyEmail.js
import { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  FaCut,
  FaCheckCircle,
  FaTimesCircle,
  FaSpinner,
  FaCalendarCheck,
} from 'react-icons/fa';
import './Auth.css';
import { baseurl } from '../Baseurl';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Verification token is missing.');
        return;
      }

      try {
        const res = await axios.get(`${baseurl}/auth/verify-email`, {
          params: { token },
        });

        setStatus('success');
        setMessage(res.data.message || 'Email verified successfully.');

        setTimeout(() => {
          navigate('/');
        }, 3000);
      } catch (err) {
        setStatus('error');
        setMessage(
          err.response?.data?.message || 'Verification failed. The link may be invalid or expired.'
        );
      }
    };

    verify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="auth-page">
      <div className="auth-wrapper">
        {/* LEFT PANEL */}
        <div className="auth-visual">
          <div className="visual-top">
            <div className="brand-row">
              <span className="brand-icon-box">
                <FaCut />
              </span>
              <span className="brand-name">Glow & Style</span>
            </div>
            <div className="badge-pill">
              <FaCalendarCheck className="badge-icon" />
              SALON BILLING PLATFORM
            </div>

            <h1 className="visual-heading">
              Almost there — <br />
              let's confirm <br />
              <span>it's really you</span>
            </h1>

            <p className="visual-text">
              Verifying your email keeps your salon account secure and
              ensures billing notifications reach the right inbox.
            </p>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="auth-form-side">
          <div className="auth-form-box verify-box">
            {status === 'verifying' && (
              <>
                <FaSpinner className="verify-icon spin" />
                <h2>Verifying your email...</h2>
                <p>Please wait while we confirm your account.</p>
              </>
            )}

            {status === 'success' && (
              <>
                <FaCheckCircle className="verify-icon success" />
                <h2>Email Verified!</h2>
                <p>{message}</p>
                <p className="fine-print">Redirecting you to login...</p>
                <Link to="/" className="auth-btn verify-btn">
                  Go to Login
                </Link>
              </>
            )}

            {status === 'error' && (
              <>
                <FaTimesCircle className="verify-icon error" />
                <h2>Verification Failed</h2>
                <p>{message}</p>
                <Link to="/" className="auth-btn verify-btn">
                  Back to Login
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;